var React = require('react');

function CheckboxesInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27.9062 1H1V27.9062H27.9062V1Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M97.9793 1H71.0731V27.9062H97.9793V1Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M63.2085 9.52199V27.9062H36.3023V1H59.7188","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":2}),React.createElement("path",{"d":"M41.4858 10.9382L49.6285 22.343L64.7506 1.15181","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":3})]);
}

CheckboxesInline.defaultProps = {"width":"99","height":"29","viewBox":"0 0 99 29","fill":"none"};

module.exports = CheckboxesInline;

CheckboxesInline.default = CheckboxesInline;
